import React from 'react'
import { Footer } from '@pcln/whitelabel-components'
import { Partner } from '../../../types'

const PartnerFooter = ({ partner }: { partner: Partner }) => (
  <div id="expr-ftr">
    <div
      className="fixed"
      id={`${partner.partnerCode}-global-footer`}
      data-testid={`${partner.partnerCode}-global-footer`}
    >
      <Footer partner={partner} />
    </div>
  </div>
)

export default PartnerFooter
